(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-alya-split-feature--pinned';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function pad(n) {
    return String(n).length < 2 ? '0' + n : String(n);
  }
  function clamp(v, min, max) {
    return Math.max(min, Math.min(max, v));
  }

  function initSection(section) {
    var track = section.querySelector('.oddit-alya-split-feature__track');
    var mediaSlides = section.querySelectorAll('.oddit-alya-split-feature__media-slide');
    var textSlides = section.querySelectorAll('.oddit-alya-split-feature__text-slide');
    var indexEl = section.querySelector('[data-asf-index]');
    var mediaEl = section.querySelector('[data-asf-media]');
    var shared = !!(mediaEl && mediaEl.hasAttribute('data-asf-shared'));
    var sharedVideo = shared ? section.querySelector('[data-asf-video]') : null;
    var soundBtn = section.querySelector('[data-asf-sound]');

    var count = shared ? textSlides.length : mediaSlides.length;
    if (!track || !count) return;
    if (shared && !sharedVideo) return;

    var total = indexEl ? Number(indexEl.getAttribute('data-asf-total')) || count : count;

    // Per-module time segments (shared-video mode).
    var segments = [];
    if (shared) {
      for (var s = 0; s < textSlides.length; s++) {
        var st = parseFloat(textSlides[s].getAttribute('data-asf-start'));
        var en = parseFloat(textSlides[s].getAttribute('data-asf-end'));
        segments.push({ start: isNaN(st) ? 0 : st, end: isNaN(en) ? Infinity : en });
      }
    }

    // Per-module videos (block-video mode).
    var blockVideos = [];
    if (!shared) {
      for (var b = 0; b < mediaSlides.length; b++) {
        blockVideos.push(mediaSlides[b].querySelector('video'));
      }
    }
    var allVideos = section.querySelectorAll('.oddit-alya-split-feature__video');

    var current = -1;
    var locked = false;
    var lockTimer = null;
    var ticking = false;
    var inView = false;
    var muted = true;
    var videosLoaded = false;

    /* ---- Video helpers -------------------------------------------------- */
    function loadVideos() {
      if (videosLoaded) return;
      videosLoaded = true;
      for (var i = 0; i < allVideos.length; i++) {
        var v = allVideos[i];
        var poster = v.getAttribute('data-poster');
        if (poster) v.setAttribute('poster', poster);
        var srcs = v.querySelectorAll('source[data-src]');
        for (var j = 0; j < srcs.length; j++) srcs[j].src = srcs[j].getAttribute('data-src');
        v.muted = muted;
        v.load();
      }
    }
    function playVid(v) {
      if (!v || reduceMotion.matches) return;
      v.muted = muted;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    function pauseAll() {
      for (var i = 0; i < allVideos.length; i++) allVideos[i].pause();
    }
    function playActiveBlockVideo(i) {
      for (var j = 0; j < blockVideos.length; j++) {
        var v = blockVideos[j];
        if (!v) continue;
        if (j === i && inView) playVid(v);
        else v.pause();
      }
    }
    function applyMuteAll() {
      for (var i = 0; i < allVideos.length; i++) allVideos[i].muted = muted;
    }

    /* ---- Slide state ---------------------------------------------------- */
    function applyState(list, active) {
      for (var j = 0; j < list.length; j++) {
        list[j].classList.toggle('is-active', j === active);
        list[j].classList.toggle('is-above', j < active);
        list[j].classList.toggle('is-below', j > active);
      }
    }

    function setActive(i) {
      if (i === current) return;
      current = i;
      applyState(mediaSlides, i);
      applyState(textSlides, i);
      if (indexEl) indexEl.textContent = pad(i + 1) + '/' + pad(total);
      // The shared video is NEVER seeked — it plays continuously; the copy just
      // follows its timestamps (or a manual scroll snap). Block videos play the
      // active clip.
      if (!shared) playActiveBlockVideo(i);
    }

    // Auto-scroll to the bottom of the section (release the pin) when the shared
    // video finishes, handing off to the next section.
    function scrollToEnd() {
      var rect = track.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var trackTopAbs = window.pageYOffset + rect.top;
      var y = trackTopAbs + rect.height - Math.round(vh * 0.5);
      locked = true;
      try {
        window.scrollTo({ top: y, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      } catch (e) {
        window.scrollTo(0, y);
      }
      if (lockTimer) clearTimeout(lockTimer);
      lockTimer = setTimeout(function () {
        locked = false;
      }, reduceMotion.matches ? 60 : 1200);
    }

    /* ---- Scroll snapping ------------------------------------------------ */
    function bandTargetY(k) {
      var rect = track.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var scrollable = Math.max(rect.height - vh, 0);
      var denom = (count - 1) || 1;
      var trackTopAbs = window.pageYOffset + rect.top;
      return trackTopAbs + (clamp(k, 0, count - 1) / denom) * scrollable;
    }

    function stepTo(k, fromVideo) {
      k = clamp(k, 0, count - 1);
      setActive(k, fromVideo);
      locked = true;
      var y = bandTargetY(k);
      try {
        window.scrollTo({ top: y, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      } catch (e) {
        window.scrollTo(0, y);
      }
      if (lockTimer) clearTimeout(lockTimer);
      lockTimer = setTimeout(function () {
        locked = false;
        measure();
      }, reduceMotion.matches ? 60 : 1000);
    }

    function measure() {
      ticking = false;
      if (locked) return;
      var rect = track.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var scrollable = rect.height - vh;
      if (scrollable <= 0) {
        setActive(0, true);
        return;
      }
      var progress = clamp(-rect.top / scrollable, 0, 1);
      var target = clamp(Math.round(progress * ((count - 1) || 1)), 0, count - 1);
      if (current < 0) {
        setActive(target, true);
        return;
      }
      if (target === current) return;
      // User scroll: advance one module and (in shared mode) seek the video.
      stepTo(current + (target > current ? 1 : -1), false);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(measure);
    }

    function engaged() {
      var rect = track.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      return rect.top <= 0 && rect.bottom >= vh;
    }
    function suppressWhileLocked(e) {
      if (locked && engaged() && e.cancelable) e.preventDefault();
    }

    /* ---- Shared video drives the copy + auto-scroll --------------------- */
    if (shared) {
      sharedVideo.addEventListener('timeupdate', function () {
        if (locked || !inView) return;
        var t = sharedVideo.currentTime;
        var vi = current;
        for (var i = 0; i < segments.length; i++) {
          if (t >= segments[i].start && t < segments[i].end) {
            vi = i;
            break;
          }
        }
        // Only auto-advance forward when the video crosses into a later segment.
        if (vi > current) stepTo(vi);
      });

      // Video finished → auto-scroll to the bottom of the section.
      sharedVideo.addEventListener('ended', function () {
        if (inView) scrollToEnd();
      });
    }

    /* ---- Lazy load + play/pause when the section is on screen ----------- */
    if ('IntersectionObserver' in window) {
      var loadIO = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              loadVideos();
              loadIO.disconnect();
            }
          });
        },
        { rootMargin: '400px 0px' }
      );
      loadIO.observe(section);

      var playIO = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            inView = entry.isIntersecting;
            if (inView) {
              loadVideos();
              if (shared) {
                // Re-entering after it finished → replay from the start.
                if (sharedVideo.ended) {
                  try {
                    sharedVideo.currentTime = 0;
                  } catch (e) {}
                }
                playVid(sharedVideo);
              } else {
                playActiveBlockVideo(current);
              }
            } else {
              pauseAll();
            }
          });
        },
        { threshold: 0.01 }
      );
      playIO.observe(section);
    } else {
      loadVideos();
      inView = true;
    }

    /* ---- Sound toggle --------------------------------------------------- */
    if (soundBtn) {
      soundBtn.addEventListener('click', function () {
        muted = !muted;
        applyMuteAll();
        // If unmuting, make sure the active video is actually playing.
        if (!muted) {
          if (shared) playVid(sharedVideo);
          else playActiveBlockVideo(current);
        }
        soundBtn.classList.toggle('is-muted', muted);
        soundBtn.setAttribute('aria-pressed', muted ? 'false' : 'true');
        soundBtn.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
      });
    }

    setActive(0, true);
    measure();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    window.addEventListener('wheel', suppressWhileLocked, { passive: false });
    window.addEventListener('touchmove', suppressWhileLocked, { passive: false });
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();
